import {
  Tr, Tbody, Td,
  useDisclosure,
  Button,
  Text,
} from '@chakra-ui/react';
import { get } from '@submize/lodash';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useFormColumns from './useFormColumns';
import { formatDate } from '../../helpers/date';
import { useLazyGetFormSubmissionsQuery, useReadSubmitionMutation } from '../../Services/apiSlice';
import TableFallback from '../../Components/Loader/TableFallback';
import SubmitionViewModal from './SubmitionModal';
import './styles.css';

const TableBody = ({ search }) => {
  const cols = useFormColumns();
  const { formId } = useParams();
  const [trigger, {
    data, isFetching, isLoading, isUninitialized,
  }] = useLazyGetFormSubmissionsQuery();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selected, setSelected] = useState();
  const [setSubmitionAsRead] = useReadSubmitionMutation();

  const handleRowClick = (rowId) => {
    setSelected(rowId);
    onOpen();
  };

  const setRead = (item) => {
    if (!item.read) {
      setSubmitionAsRead({
        formId,
        submitionId: item.id,
        submition: item,
      });
    }
  };
  const openNext = () => {
    if (selected >= data.items.length - 1) return;
    setRead(data.items[selected]);
    setSelected(selected + 1);
  };
  const openPrev = () => {
    if (selected === 0) return;
    setRead(data.items[selected]);
    setSelected(selected - 1);
  };
  const handleCloseModal = () => {
    setRead(data.items[selected]);
    onClose();
  };

  const searchFn = ({ next }) => trigger({ formId, next, search }, true);
  useEffect(() => {
    searchFn({ next: '', search });
  }, [search]);

  if (isUninitialized || isLoading) {
    return <Tbody><TableFallback /></Tbody>;
  }
  return (
    <>
      <Tbody>
        {data.items.map((row, id) => (
          <Tr
            key={id}
            fontWeight={row.read ? 'normal' : 'bold'}
            cursor="pointer"
            _hover={{ bg: 'gray.200' }}
            onClick={() => handleRowClick(id)}
            className={row.new ? 'new-row' : ''}
          >
            <Td whiteSpace="nowrap">{formatDate(row.date)}</Td>
            {cols.map((col, c) => (
              <Td
                key={c}
                px="3"
                maxW="150px"
                textOverflow="ellipsis"
                overflow="hidden"
              >
                {get(row, `data.${col.path}`, '')}
              </Td>
            ))}
          </Tr>
        ))}
        {data.items.length === 0 && (
          <Tr>
            <Td colSpan={cols.length + 1} textAlign="center">
              <Text my="4" color="gray.500">
                {search ? 'There are no results for your search' : 'There are no submissions yet'}
              </Text>
            </Td>
          </Tr>
        )}
      </Tbody>
      <Tbody>
        <Tr>
          <Td colSpan={cols.length + 1} border="none">
            {data.next && (
              <Button size="sm" float="right" onClick={() => searchFn({ next: data.next })} isLoading={isFetching}>
                Load more submissions
              </Button>
            )}
          </Td>
        </Tr>
      </Tbody>
      <SubmitionViewModal
        isOpen={isOpen}
        onClose={handleCloseModal}
        item={data.items[selected]}
        cols={cols}
        next={selected < data.items.length - 1 && openNext}
        prev={selected > 0 && openPrev}
      />
    </>
  );
};

export default TableBody;
